import { Route, Routes } from "react-router-dom";
import ControlAppVersion from "../pages/dashboardPage/appVersionSettings/controlAppVersion/ControlAppVersion";

const AppVersionNavigator = () => {
  return (
    <Routes>
      <Route path="/app-version" element={<ControlAppVersion />} />
      <Route path="*" element={<ControlAppVersion />} />
    </Routes>
  );
};

export default AppVersionNavigator;
